module.exports = __webpack_public_path__ + "img/logo-cloud-rent.926117b1.png";